module.exports = __webpack_public_path__ + "static/media/aguilas.8bad34da.png";